import React,{useState,useEffect } from "react";
import Summary from "./components/Summary";
import moment from "moment";
import reportService from "../../services/reportService";
import { LoadingSpinner } from "../../components";
import HeaderTitle from "../../components/HeaderTitle";
import ReportByMixMobile from "./mobile/ReportByMixMobile";
import { useWindowWidth } from '@react-hook/window-size';
import CustomNoData from "../../components/CustomNoData";
import CustomCalendarSVG from "../../components/CustomCalendarSVG";
import CustomSearchBtn from "../../components/CustomSearchBtn";
import { FiChevronDown } from "react-icons/fi";

const filterType = [
  { value: "all", label: "All Events" },
  { value: "notStarted", label: "Not Started" },
  { value: "completed", label: "Completed" },
  { value: "playing", label: "Playing" }
];

const sortingType = [
  { value: "amount-asc", label: "Sort By Amount" },
  { value: "amount-desc", label: "Sort By Amount" }
];

const ReportByMix = () => {
  const onlyWidth = useWindowWidth();
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [selectedFilter, setSelectedFilter] = useState();
  const [selectedSorting, setSelectedSorting] = useState();
  const [showEvents, setShowEvents] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const theme = sessionStorage.getItem("smartReportTheme") || "light";

  const fetchData = async() => {
    try {
      setIsLoading(true);
      const response = await reportService.reportByMixTotal(date);

      if (response.status === 200) {
        setReportData(response.data.data);
        setShowEvents(response.data.data);
      }
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setSelectedFilter(filterType[0]);
    setSelectedSorting(sortingType[0]);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelect = (v) => {
    setSelectedFilter(v);
    let value = v.value;
    let filteredData;

    switch (value) {
      case 'all':
        setShowEvents(reportData);
        break;
      case 'notStarted':
        filteredData = reportData.filter(a => a.eventStatus === 0);
        setShowEvents(filteredData);
        break;
      case 'completed':
        filteredData = reportData.filter(a => a.eventStatus === 3);
        setShowEvents(filteredData);
        break;
      case 'playing':
        filteredData = reportData.filter(a => a.eventStatus === 1);
        setShowEvents(filteredData);
        break;
      default:
        filteredData=[];
        break;
    }
  };

  const handleSorting = (v) => {   
  setSelectedSorting(v);
    let value = v.value;
    let sortedData;

    switch (value) {
      case 'amount-asc':
        sortedData = reportData.sort((a, b) => Math.abs(a.overAmount) - Math.abs(b.overAmount));
        setShowEvents(sortedData);
        console.log('Sorting selected: 555', sortedData);
        break;
      case 'amount-desc':
        sortedData = reportData.sort((a, b) => Math.abs(b.overAmount) - Math.abs(a.overAmount));
        setShowEvents(sortedData);
        console.log('Sorting selected: 666', sortedData);
        break;
      default:
        break;
    }
  };

  const handleSearch = async () => {
    await fetchData();
  };

  return (
    <div className="min-h-screen bg-customLightMilkWhite px-4 py-3 pb-20 text-customInk dark:bg-custom_dark_background dark:text-customWhite">
      <div className='my-1'>
        <HeaderTitle title={"Mix Report"} width={onlyWidth} />
      </div>
      <section className="mb-4 overflow-hidden rounded-2xl border border-customTitleColor bg-white shadow-accountPanel dark:border-customBorder dark:bg-customSurface">
        <div className="grid grid-cols-1 gap-4 border-b border-customTitleColor bg-customGray px-6 py-4 dark:border-customBorder dark:bg-customSurfaceMuted md:grid-cols-[280px_230px_200px]">
          <div className="flex items-center">
            <label className="block">
              <span className="mb-2 block text-[0.68rem] font-bold text-customSecondaryText dark:text-customMuted">Date</span>
              <div className="relative">
                <input
                  type="date"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                  className="h-10 w-full rounded-xl border border-customTitleColor bg-white pl-3 pr-3 text-xs font-medium text-customInk outline-none transition focus:border-customAccentBlue dark:border-customBorder dark:bg-customSurface dark:text-customWhite"
                />
                <CustomCalendarSVG />
              </div>
            </label>
            <div className="mt-[1.58rem]">
              <CustomSearchBtn handleSearch={handleSearch} />
            </div>
          </div>

          <label className="block">
            <span className="mb-2 block text-[0.68rem] font-bold text-customSecondaryText dark:text-customMuted">Event type</span>
            <div className="relative">
              <select
                value={selectedFilter?.value || filterType[0].value}
                onChange={(event) => handleSelect(filterType.find(item => item.value === event.target.value))}
                className="h-10 w-full appearance-none rounded-xl border border-customTitleColor bg-white px-4 pr-10 text-xs font-medium text-customInk outline-none transition focus:border-customAccentBlue dark:border-customBorder dark:bg-customSurface dark:text-customWhite"
              >
                {filterType.map((item) => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
              <FiChevronDown className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-customInk dark:text-customWhite" />
            </div>
          </label>

          <label className="block">
            <span className="mb-2 block text-[0.68rem] font-bold text-customSecondaryText dark:text-customMuted">Sort by</span>
            <div className="relative">
              <select
                value={selectedSorting?.value || sortingType[0].value}
                onChange={(event) => handleSorting(sortingType.find(item => item.value === event.target.value))}
                className="h-10 w-full appearance-none rounded-xl border border-customTitleColor bg-white px-4 pr-10 text-xs font-medium text-customInk outline-none transition focus:border-customAccentBlue dark:border-customBorder dark:bg-customSurface dark:text-customWhite"
              >
                {sortingType.map((item) => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
              <FiChevronDown className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-customInk dark:text-customWhite" />
            </div>
          </label>
        </div>
      </section>
        {
          isLoading ? <LoadingSpinner /> :
            showEvents.length > 0 ?
              onlyWidth > 768 ?
                showEvents.map((v, i) => {
                  return <Summary data={v} key={i} fetchData={fetchData} theme={theme}/>
                })
                :
                <ReportByMixMobile showEvents={showEvents} fetchData={fetchData} />
              :
                <CustomNoData title="No mix report data" description="No betting data found for the selected date range." />
        }
    </div>
  );
};

export default ReportByMix;


